if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"core","remotes":[{"alias":"@frodo","name":"frodo","entry":"/frodo/remoteEntry_frodo.js","shareScope":"default"}],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return 803 != chunkId},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}